import { BadgeText as Container } from "./styles";

export function BadgeText({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>;
}
